// src/components/ui/CardSkeleton.tsx
import React from "react";

export default function CardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden h-full flex flex-col animate-pulse">
      {/* Image Skeleton */}
      <div className="w-full h-48 bg-gray-200"></div>

      {/* Content Skeleton */}
      <div className="p-4 flex flex-col flex-grow space-y-3">
        {/* Brand Name */}
        <div className="h-3 bg-gray-300 rounded w-24"></div>

        {/* Model Name */}
        <div className="h-5 bg-gray-300 rounded w-3/4"></div>

        {/* Price */}
        <div className="h-7 bg-gray-300 rounded w-1/2 mt-2"></div>

        {/* Button */}
        <div className="mt-auto">
          <div className="h-10 bg-gray-300 rounded-lg w-full"></div>
        </div>
      </div>
    </div>
  );
}